const defaults = {
    onMove: () => {},
    onSwipe: () => {},
};

/**
 * @param {{handles: Element[], [onMove]: function, [onSwipe]: function}} options
 */
export const Gestures = (options) => {
    const parameters = {
        startPosition: {x: 0, y: 0},
        delta: {x: 0, y: 0},
        started: false,
    };

    options = {...defaults, ...options};

    const buildEvent = () => {
        let movement = {
            horizontal: {
                direction: parameters.delta.x < 0 ? 'left' : 'right',
                delta: Math.abs(parameters.delta.x)
            },
            vertical: {
                direction: parameters.delta.y < 0 ? 'up' : 'down',
                delta: Math.abs(parameters.delta.y)
            }
        };

        const intent = movement.horizontal.delta > movement.vertical.delta ? 'horizontal' : 'vertical';

        return {
            intent: {
                direction: movement[intent].direction,
                delta: movement[intent].delta
            },
            delta: {
                x: parameters.delta.x,
                y: parameters.delta.y
            },
            movement: movement
        };
    };

    const isTargetHandle = (event) => {
        // clean up handles that are removed from the DOM
        for (let i = 0; i < options.handles.length; i++) {
            if (document.body.contains(options.handles[i])) {
                continue;
            }

            options.handles.splice(i, 1);
        }

        // clean up event listeners when no handlers are available anymore
        if (!options.handles.length) {
            document.removeEventListener('touchstart', handleSwipeStart);
            document.removeEventListener('touchmove', handleSwipeMove);
            document.removeEventListener('touchend', handleSwipeEnd);
        }

        // check if the current target is a valid handle
        for (let i = 0; i < options.handles.length; i++) {
            if (!options.handles[i].contains(event.target)) {
                continue;
            }

            return true;
        }

        return false;
    };

    const handleSwipeStart = (event) => {
        if (!isTargetHandle(event)) {
            return;
        }

        parameters.started = true;

        document.querySelector('html').style.overscrollBehavior = 'none';
        document.querySelector('body').style.overscrollBehavior = 'none';

        parameters.startPosition.x = event.touches[0].clientX;
        parameters.startPosition.y = event.touches[0].clientY;

        document.querySelector('body').style.overflow = 'hidden';
    };

    const handleSwipeMove = function (event) {
        if (!parameters.started) {
            return;
        }

        event.stopPropagation();

        parameters.delta.x = event.touches[0].clientX - parameters.startPosition.x;
        parameters.delta.y = event.touches[0].clientY - parameters.startPosition.y;

        options.onMove(buildEvent());
    };

    const handleSwipeEnd = () => {
        if (!parameters.started) {
            return;
        }

        document.querySelector('html').style.overscrollBehavior = 'auto';
        document.querySelector('body').style.overscrollBehavior = 'auto';

        options.onSwipe(buildEvent());

        parameters.startPosition = {x: 0, y: 0};
        parameters.delta = {x: 0, y: 0};
        parameters.started = false;

        document.querySelector('body').style.overflow = '';
    };

    document.addEventListener('touchstart', handleSwipeStart);
    document.addEventListener('touchmove', handleSwipeMove);
    document.addEventListener('touchend', handleSwipeEnd);
};
